module.exports = __webpack_public_path__ + "img/fall-4@3x.90ffecf5.png";